import { useSelector } from '@ecommerce/nest-ssr/common';
import React, { useEffect, useRef } from 'react';
import { ModalsState } from '../../../reducers/modals';
import { useScrollLock } from 'hooks/use-scroll-lock';

export const Modals: React.FC = () => {
    const { lock, unlock } = useScrollLock();
    const body = useRef<HTMLBodyElement | null>(null);
    const isAnyOpen = useSelector((state: { modals: { openedModal: ModalsState; }; }) => state.modals?.openedModal);

    useEffect(() => {
        body.current = document.querySelector('body');
    }, []);

    useEffect(() => {
        if (isAnyOpen) {
            lock();
            document.documentElement.scrollTop = window.scrollY;
            document.body.style.overflow = 'hidden';
        } else {
            unlock();
            document.body.style.overflow = 'auto';
        }
    }, [isAnyOpen]);

    return null;
};
